import { Rating } from 'primereact/rating'
import React from 'react'
import { Controller } from 'react-hook-form'
import { FormInput } from '../../../components/FormInput'
import { EnergyRating } from '../../../components/EnergyRating'
import { useTranslation } from 'react-i18next'

const FiveRatingForm = ({
    control,
    register,
    errors,
    editAction,
    isEditable
}) => {
    const { t } = useTranslation();
    const ratingTooltip1 = t('activity_data')
    const ratingTooltip2 = t('emissionFactor')
    return (
        <>
            <div className="col-12 ">
                <label className="font-semibold">{t('stage.dataQualtity')}</label>
            </div>
            {/* 來源可靠性 */}
            <div className="col-12 flex md:flex-no-wrap flex-wrap align-items-center">
                <label className='w-full md:w-2 mb-2 md:mb-0'>{t('sourceReliability')}</label>
                <div className='flex gap-2 align-items-center  md:flex-no-wrap flex-wrap'>
                    <EnergyRating name={"dataReliability"} control={control} tooltip={ratingTooltip1} disabled={!isEditable}></EnergyRating>
                    <EnergyRating name={"coefReliability"} control={control} tooltip={ratingTooltip2} disabled={!isEditable}></EnergyRating>
                    <FormInput
                        disabled={!isEditable}
                        register={register}
                        errors={errors}
                        id="reliabilityRemark"
                        type="text"
                        wrapperClass="md:w-auto w-full"
                        placeholder={t('plzFillInReason')}
                    />
                </div>
                {/* <div>
                </div> */}
            </div>
            {/* 完整性 */}
            <div className="col-12 flex md:flex-no-wrap flex-wrap align-items-center">
                <label className='w-full md:w-2 mb-2 md:mb-0'>{t('completeness')}</label>
                <div className='flex gap-2 align-items-center  md:flex-no-wrap flex-wrap'>
                    <EnergyRating name={"dataIntegrity"} control={control} tooltip={ratingTooltip1} disabled={!isEditable}></EnergyRating>
                    <EnergyRating name={"coefIntegrity"} control={control} tooltip={ratingTooltip2} disabled={!isEditable}></EnergyRating>
                    <FormInput
                        disabled={!isEditable}
                        register={register}
                        errors={errors}
                        id="integrityRemark"
                        type="text"
                        wrapperClass="md:w-auto w-full"
                        placeholder={t('plzFillInReason')}
                    />
                </div>
            </div>
            {/* 時間相關性 */}
            <div className="col-12 flex md:flex-no-wrap flex-wrap align-items-center">
                <label className='w-full md:w-2 mb-2 md:mb-0'>{t('temporalRepresentativeness')}</label>
                <div className='flex gap-2 align-items-center  md:flex-no-wrap flex-wrap'>
                    <EnergyRating name={"dataTimeliness"} control={control} tooltip={ratingTooltip1} disabled={!isEditable}></EnergyRating>
                    <EnergyRating name={"coefTimeliness"} control={control} tooltip={ratingTooltip2} disabled={!isEditable}></EnergyRating>
                    <FormInput
                        disabled={!isEditable}
                        register={register}
                        errors={errors}
                        id="timelinessRemark"
                        type="text"
                        wrapperClass="md:w-auto w-full"
                        placeholder={t('plzFillInReason')}
                    />
                </div>
            </div>
            {/* 地理相關性 */}
            <div className="col-12 flex md:flex-no-wrap flex-wrap align-items-center">
                <label className='w-full md:w-2 mb-2 md:mb-0'>{t('geographicalRepresentativeness')}</label>
                <div className='flex gap-2 align-items-center  md:flex-no-wrap flex-wrap'>
                    <EnergyRating name={"dataLocation"} control={control} tooltip={ratingTooltip1} disabled={!isEditable}></EnergyRating>
                    <EnergyRating name={"coefLocation"} control={control} tooltip={ratingTooltip2} disabled={!isEditable}></EnergyRating>
                    <FormInput
                        disabled={!isEditable}
                        register={register}
                        errors={errors}
                        id="locationRemark"
                        type="text"
                        placeholder={t('plzFillInReason')}
                        wrapperClass="md:w-auto w-full"
                    />
                </div>
            </div>
            {/* 技術相關性 */}
            <div className="col-12 flex md:flex-no-wrap flex-wrap align-items-center">
                <label className='w-full md:w-2 mb-2 md:mb-0'>{t('technologicalRepresentativeness')}</label>
                <div className='flex gap-2 align-items-center  md:flex-no-wrap flex-wrap'>
                    <EnergyRating name={"dataTechnical"} control={control} tooltip={ratingTooltip1} disabled={!isEditable}></EnergyRating>
                    <EnergyRating name={"coefTechnical"} control={control} tooltip={ratingTooltip2} disabled={!isEditable}></EnergyRating>
                    <FormInput
                        disabled={!isEditable}
                        register={register}
                        errors={errors}
                        id="technicalRemark"
                        type="text"
                        placeholder={t('plzFillInReason')}
                        wrapperClass="md:w-auto w-full"
                    />
                </div>
            </div>
        </>
    )
}

export default FiveRatingForm